module.exports = __webpack_public_path__ + "img/walker-corner.33eff7e8.jpg";